import {DarkStoreType} from "../../../../common/types";
import ReactApexChart from "react-apexcharts";
import React from "react";

// Тип пропсов для компонента, ожидается массив данных по дарксторам
type BigStoreIndicatorsPropsType = {
    data: DarkStoreType[];
}

// Основной компонент для отображения зон доставки больших лавок
export const BigStoreIndicators = ({data}: BigStoreIndicatorsPropsType) => {
    // Объект для хранения количества зон доставки больших лавок
    let bigStores: { [key: string]: number } = {}
    // Перебор массива данных и подсчёт количества лавок по каждой зоне доставки
    data.forEach((el) => {
        if (el.otkuda_dostavka_bolshoy_lavki) {
            if (!Object.keys(bigStores).includes(el.otkuda_dostavka_bolshoy_lavki)) {
                bigStores = {...bigStores, [el.otkuda_dostavka_bolshoy_lavki]: 1}
            } else {
                bigStores[el.otkuda_dostavka_bolshoy_lavki] += 1
            }
        }
    })

    // Массив названий зон доставки для оси X (категории)
    const categories = Object.keys(bigStores)
    // Массив значений для графика (количество лавок по зонам доставки)
    const series = Object.values(bigStores)

    // Опции для круговой диаграммы ApexCharts
    const options = {
        chart: {
            width: 380,
            type: 'pie' as const,
        },
        labels: categories,
        title: {
            text: 'Зоны доставки Больших лавок',
            align: 'center' as const,
            margin: 20,
            style: {
                fontSize: '16px',
                fontWeight: 'bold' as const,
                color: '#FFFFFF'
            },
        },
        legend: {
            labels: {
                colors: '#FFFFFF'
            },
            position: 'bottom' as const
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }],
        tooltip: {
            y: {
                formatter: function (value: any) {
                    return value + ' ' + 'лавок'
                }
            }
        }
    }

    // Рендерим круговую диаграмму по зонам доставки больших лавок
    return (
        <div>
            <ReactApexChart
                options={options}
                series={series}
                type={'pie'}
                height={500}
                style={{color: '#FFFFFF'}}
            />
        </div>
    );
};
